import { render, staticRenderFns } from "./IndexSlider.vue?vue&type=template&id=c022d1be&scoped=true&"
import script from "./IndexSlider.vue?vue&type=script&lang=js&"
export * from "./IndexSlider.vue?vue&type=script&lang=js&"
import style0 from "./IndexSlider.vue?vue&type=style&index=0&id=c022d1be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c022d1be",
  null
  
)

export default component.exports